import { initBCTabs } from "./bc-tabs.js";
import { initBCTooltip } from "./bc-tooltip.js";
import { initBCLoadingIcon } from "./bc-loading-icon.js";
import { initBCAbbr } from "./bc-abbr.js";
export { initBCTabs, initBCTooltip, initBCLoadingIcon, initBCAbbr };
